import { BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('/auth/permission');
  }
}

export default new API();
